import styled from "styled-components";
import { primaryColor, primaryColorHover } from "../../../../config/constants";

export const ActionsContainer = styled.div`
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 610px) {
    margin-bottom: 10px;
    padding: 10px;
    height: auto;
  }
`;
export const ManagementDiv = styled.div`
  width: 100%;
  max-width: 860px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 910px) {
    width: 85%;
  }
  @media (max-width: 610px) {
    flex-direction: column;
  }
`;
export const SaveAndCancelDiv = styled.div`
  height: 38px;
  display: flex;
`;
export const SaveButton = styled.button`
  margin-right: 10px;
  padding: 10px;
  width: 108px;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background-color: ${primaryColor};
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
`;
export const CancelButton = styled.button`
  padding: 0 10px;
  height: 38px;
  border: 1px solid ${primaryColor};
  border-radius: 5px;
  color: ${primaryColor};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background: transparent;
  outline: none;
  cursor: pointer;
`;
export const ColorToggleDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const ColorToggleText = styled.p`
  color: #808080;
  font-size: 14px;
`;
